import type { ResourcesConfig } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils'

// 本番デプロイ時は portal 配下の Cookie でトークンを共有するため、
// portal と同じ client_id を使う。localhost 開発時はこのアプリ独自の client_id で
// 既存の Google サインインを維持する。
const sharedClientId = import.meta.env.VITE_COGNITO_SHARED_CLIENT_ID
const isSharedSession = Boolean(sharedClientId && import.meta.env.VITE_COOKIE_DOMAIN)

export const isLocalhostSignIn = !isSharedSession

export const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId:
        import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-northeast-1_XXXXXXXXX',
      userPoolClientId:
        sharedClientId ||
        import.meta.env.VITE_COGNITO_CLIENT_ID ||
        'xxxxxxxxxxxxxxxxxxxxxxxxxx',
      loginWith: {
        oauth: {
          domain:
            import.meta.env.VITE_COGNITO_DOMAIN ||
            'hakuou-dev.auth.ap-northeast-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            'http://localhost:5176/callback',
            'https://um-dev.app.hakuou.co.jp/callback',
            'https://um.app.hakuou.co.jp/callback',
          ],
          redirectSignOut: [
            'http://localhost:5176',
            'https://um-dev.app.hakuou.co.jp',
            'https://um.app.hakuou.co.jp',
          ],
          responseType: 'code',
          providers: ['Google'],
        },
      },
    },
  },
}

// NOTE: Amplify.configure() の "後" に呼ぶ必要があるため main.tsx 側から明示的に実行する。
export function configureCookieStorage() {
  const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN
  if (!cookieDomain) return
  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({
      domain: cookieDomain,
      secure: true,
      path: '/',
      sameSite: 'lax',
    }),
  )
}

export const apiConfig = {
  baseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    'https://xxxxxxxxxx.execute-api.ap-northeast-1.amazonaws.com/dev',
}

export const hakuouApiConfig = {
  baseUrl: import.meta.env.VITE_HAKUOU_API_BASE_URL || '/hakuou-api',
}
